import { Component, OnInit } from '@angular/core';
import { AdminAuthService } from '../shared/services/auth.service';

@Component({
    selector: 'app-dashboard',
    imports: [],
    templateUrl: './dashboard.component.html',
    styleUrl: './dashboard.component.scss'
})
export class DashboardComponent implements OnInit {

    public isAuthorized: boolean = true;

    constructor(private adminAuthService: AdminAuthService) {}

    ngOnInit(): void {
        this.isAuthorized = this.adminAuthService.isLoggedIn();

        if (this.isAuthorized)
            this.adminAuthService.setLandingPage();
    }

}
